/**
 * 三菱電機組織用の共通処理
 * URL構造のカスタマイズ
 */

import Page from '@/services/Page.js'

/**
 * Page.js の上書き（主にURLまわりの調整）
 */
function overridePage() {
  
  // 店舗の一覧
  Page.baseUrls.points = `/list/`

  // 店舗の一覧ページのURL生成を上書き
  Page.getPointsUrl = (area_code = null, params = []) => {
    const url = area_code ? `/areas/${area_code}/list/` : Page.baseUrls.points
    const query = Page.getForwardQuery()

    Page.mergeQuery(query, params)

    const queryString = query.join("&")

    return url + (queryString ? `?${queryString}` : "")
  }

  // 店舗の一覧ページからきたか判定を上書き
  Page.isFromPointsPage = (url = null) => {
    const fixedUrl = url || document.referrer
    // /list/ で始まり、その後にクエリパラメータやハッシュが続く場合を判定
    return fixedUrl.match(/\/list\/($|\?|#)/) !== null
  }
}   

/**
 * 共通処理の初期化
 */
export function overrideCommon() {
  overridePage()
}